import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import CommonModal from 'PhishingManager/components/Modal';

export type TemplateActionType = 'save_changes' | 'unpublish' | 'publish';

interface TemplateActionModalProps {
  visible: boolean;
  loading?: boolean;
  type: TemplateActionType;
  onClose: () => void;
  onConfirm: () => void;
}

export const TemplateActionModal: React.FC<TemplateActionModalProps> = ({
  visible,
  loading = false,
  type,
  onClose,
  onConfirm
}) => {
  const { t } = useTranslation();

  const config = useMemo(() => {
    const configurations = {
      save_changes: {
        title: t('phishingTemplateManager.actionModal.saveChangesTitle'),
        desc: [
          t('phishingTemplateManager.actionModal.saveChangesDesc1'),
          t('phishingTemplateManager.actionModal.saveChangesDesc2')
        ],
        confirmText: t('saveChanges')
      },
      unpublish: {
        title: t('phishingTemplateManager.actionModal.unpublishTitle'),
        desc: [
          t('phishingTemplateManager.actionModal.unpublishDesc1'),
          t('phishingTemplateManager.actionModal.unpublishDesc2')
        ],
        confirmText: t('phishingTemplateManager.actionModal.unpublishConfirmBtn')
      },
      publish: {
        title: t('phishingTemplateManager.actionModal.publishTitle'),
        desc: [
          t('phishingTemplateManager.actionModal.publishDesc1'),
          t('phishingTemplateManager.actionModal.publishDesc2')
        ],
        confirmText: t('phishingTemplateManager.actionModal.publishConfirmBtn')
      }
    };

    return configurations[type];
  }, [type, t]);

  return (
    <CommonModal
      visible={visible}
      showConfirmBtn={true}
      confirmBtnDisabled={loading}
      confirmText={
        loading
          ? t('phishingTemplateManager.actionModal.processing')
          : config.confirmText
      }
      cancelText={t('cancel')}
      iconType={null}
      onClose={onClose}
      onConfirm={onConfirm}
      modalTitle={config.title}
      parentClass="template-action-modal"
      modalContentDesc={config.desc}
    />
  );
};

export default TemplateActionModal;